import hljs from "highlight.js";
import 'highlight.js/styles/github.css';

hljs.configure({
  languages: ['javascript', 'cpp', 'python', 'go', 'java'],
})
window.hljs = hljs